export enum INSTRUCTION_STATUS {
  DRAFT = 0, // instruction not yet saved
  PROCESSING = 1, // code is being generated
  READY = 2, // code generated, ready to be used in a workflow
  FAILED = 3, // failed to generate code
  VIEW_ONLY = 4, // view only mode for historical version
}

export type InstructionStatus = INSTRUCTION_STATUS
